import { _ as _objectWithoutPropertiesLoose, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-959e870d.js';
import 'react';
import { useSealedState } from 'reakit-utils/useSealedState';
import 'reakit-utils/applyState';
import '../Id/IdProvider.js';
import '../Id/IdState.js';
import { u as unstable_useCompositeState } from '../CompositeState-de01a7f3.js';

function useToolbarState(initialState) {
  if (initialState === void 0) {
    initialState = {};
  }

  var _useSealedState = useSealedState(initialState),
      _useSealedState$orien = _useSealedState.orientation,
      orientation = _useSealedState$orien === void 0 ? "horizontal" : _useSealedState$orien,
      sealed = _objectWithoutPropertiesLoose(_useSealedState, ["orientation"]);

  return unstable_useCompositeState(_objectSpread2({
    orientation: orientation
  }, sealed));
}
var keys = [].concat(unstable_useCompositeState.__keys);
useToolbarState.__keys = keys;

export { useToolbarState };
